import { defineComponent as u, computed as p, h as f } from "vue";
import h from "./highrise808.mjs";
import b from "./highrise677.mjs";
import s from "./highrise678.mjs";
import v from "./highrise809.mjs";
import { useThemeClass as g } from "./highrise680.mjs";
import { formatLength as t } from "./highrise781.mjs";
const C = Object.assign(Object.assign({}, s.props), {
  size: {
    type: Number,
    default: 24
  },
  borderRadius: {
    type: Number,
    default: 6
  },
  color: String,
  iconColor: String
}), O = u({
  name: "IconWrapper",
  props: C,
  setup(e, {
    slots: c
  }) {
    const {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: l
    } = b(e), a = s("IconWrapper", "-icon-wrapper", h, v, e, i), r = p(() => {
      const {
        common: {
          cubicBezierEaseInOut: n
        },
        self: {
          color: m,
          iconColor: d
        }
      } = a.value;
      return {
        "--n-bezier": n,
        "--n-color": m,
        "--n-icon-color": d
      };
    }), o = l ? g("icon-wrapper", void 0, r, e) : void 0;
    return () => {
      const n = t(e.size);
      return o == null || o.onRender(), f("div", {
        class: [`${i.value}-icon-wrapper`, o == null ? void 0 : o.themeClass.value],
        style: [r == null ? void 0 : r.value, {
          height: n,
          width: n,
          borderRadius: t(e.borderRadius),
          backgroundColor: e.color,
          color: e.iconColor
        }]
      }, c);
    };
  }
});
export {
  O as NIconWrapper,
  C as iconWrapperProps
};
